import React, { Component } from 'react';
import { ContentBox } from './content-box/ContentBox';

class AdjacentContentBox extends Component {
    render() {
        return (
            <ContentBox
                contentBoxStyle="adjacent-content-box"
                title={this.props.title}
                subtitle={this.props.subtitle}
                content={this.props.content}
                tooltipMessage={this.props.tooltipMessage}
            />
        );
    }
}

export default AdjacentContentBox;
